<template>
    <external-list
            :headlines="[{text: 'Title', width: 5}, {text: 'URL', width: 5}]"
            endpoint="/api/v2/marketing-site-pages"
            :endpoint-filters="{portal_id: portal.id, language: language}"
            :can-destroy="() => true"
            @show="show"
    >
        <template v-slot:default="{ row: page }">
            <td>
                <router-link :to="getUrl(page)">
                    {{ page.attributes.title }}
                </router-link>
            </td>

            <td>
                {{ page.attributes.url }}
            </td>
        </template>

        <template v-slot:modals="{ load }">
            <create-modal :portal="portal" :language="language" @created="load"/>
        </template>
    </external-list>
</template>

<script>
    import CreateModal from '@/components/Modals/Administration/MarketingSites/Pages/Create'
    import ExternalList from '@/components/Panels/Lists/External'

    export default {
        components: {CreateModal, ExternalList},

        props: {
            portal: {
                required: true
            },

            language: {
                required: true
            }
        },

        methods: {
            show(page) {
                this.$router.push(this.getUrl(page))
            },

            getUrl(page) {
                return '/marketing-sites/' + this.portal.id + '/pages/' + page.id
            }
        }
    }
</script>
